module.exports = __webpack_public_path__ + "static/media/cocina.8134f60a.png";